module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scroll-y"
  }, [_c('div', {
    staticClass: "container-fluid py-2 align-items-center my-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "row justify-content-end"
  }, [_c('div', {
    staticClass: "col-sm-6 d-flex flex-row align-items-center"
  }, [_c('label', {
    staticClass: "mr-2 darker"
  }, [_vm._v("Departure Date:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.dateOptions,
      "onChange": _vm.changeTimeOption
    },
    model: {
      value: (_vm.selectedDateOption),
      callback: function($$v) {
        _vm.selectedDateOption = $$v
      },
      expression: "selectedDateOption"
    }
  })], 1), _vm._v(" "), (_vm.showDatePickers) ? [_c('date-range', {
    attrs: {
      "from": _vm.dateFromObj,
      "to": _vm.dateToObj
    },
    on: {
      "setFrom": _vm.setCustomDateFrom,
      "setTo": _vm.setCustomDateTo
    }
  })] : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid py-2 align-items-center my-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 d-flex justify-content-end"
  }, [_c('button', {
    staticClass: "btn tertiary",
    on: {
      "click": _vm.toggleShowGraph
    }
  }, [_vm._v(_vm._s(_vm.showCartMessage))])])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [(_vm.showGraph) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('graph', {
    staticClass: "graph py-3",
    attrs: {
      "height": 300,
      "chartData": _vm.graphData
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid bg-lightest pt-3 pb-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 d-flex flex-row align-items-center"
  }, [_c('v-select', {
    attrs: {
      "options": _vm.agentsOptions,
      "onChange": _vm.changeAgentsOption
    },
    model: {
      value: (_vm.selectedAgentsOption),
      callback: function($$v) {
        _vm.selectedAgentsOption = $$v
      },
      expression: "selectedAgentsOption"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 d-flex flex-row align-items-center"
  }, [_c('v-select', {
    attrs: {
      "options": _vm.productsOptions,
      "onChange": _vm.changeProductsOption
    },
    model: {
      value: (_vm.selectedProductsOption),
      callback: function($$v) {
        _vm.selectedProductsOption = $$v
      },
      expression: "selectedProductsOption"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 d-flex flex-row align-items-center"
  }, [_c('v-select', {
    attrs: {
      "options": _vm.statusOptions,
      "onChange": _vm.changeStatusOption
    },
    model: {
      value: (_vm.selectedStatusOption),
      callback: function($$v) {
        _vm.selectedStatusOption = $$v
      },
      expression: "selectedStatusOption"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 d-flex justify-content-end"
  }, [_c('span', {
    staticClass: "click-to-open d-flex flex-row align-items-center mr-4 pointer"
  }, [_c('i', {
    staticClass: "ico-filter medium fs-larger",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleColumnOptions.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "medium font-weight-600",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleColumnOptions.apply(null, arguments)
      }
    }
  }, [_vm._v("Column")]), _vm._v(" "), (_vm.showColumnOptions) ? _c('ul', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.toggleColumnOptions),
      expression: "toggleColumnOptions"
    }],
    staticClass: "select-drawer left"
  }, _vm._l((_vm.columnOptions), function(columnOption) {
    return _c('li', {
      staticClass: "px-2 py-1"
    }, [_c('checkbox', {
      model: {
        value: (columnOption.value),
        callback: function($$v) {
          _vm.$set(columnOption, "value", $$v)
        },
        expression: "columnOption.value"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(columnOption.label) + "\n\t\t\t\t\t\t\t\t")])], 1)
  }), 0) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "click-to-open d-flex flex-row align-items-center pointer"
  }, [_c('i', {
    staticClass: "ico-export medium fs-larger",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.exportSales.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "medium font-weight-600",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.exportSales.apply(null, arguments)
      }
    }
  }, [_vm._v("Export")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [(_vm.rowsLoaded) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('list', {
    staticClass: "w-100",
    attrs: {
      "header": _vm.header,
      "body": _vm.body,
      "rows": _vm.filteredList,
      "actions": _vm.actions
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.pageInfo) ? _c('div', {
    staticClass: "col-sm-12 d-flex justify-content-end my-4"
  }, [_c('uib-pagination', {
    attrs: {
      "total-items": _vm.pageInfo.totalItemCount,
      "boundary-link-numbers": false,
      "max-size": 7
    },
    on: {
      "change": _vm.pageChanged
    },
    model: {
      value: (_vm.pagination),
      callback: function($$v) {
        _vm.pagination = $$v
      },
      expression: "pagination"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row my-4 pt-4"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'reports'
      }
    }
  }, [_c('button', {
    staticClass: "btn add wide bg-dark",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Return to dashboard")])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "darker fs-larger font-weight-600"
  }, [_vm._v("Agent Sales Report:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bf0b1b9"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/createReport/createReport.vue
// module id = 2591
// module chunks = 0